import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import TopNavBar from '../user/top_nav_bar';
import RecipesEndUserMealItem from './recipes_end_user_meal_item';
import PopupTitle from '../common/popup_title';
import MealBasketWidget from '../../features/end_user_shopping/components/meal_basket_widget';
import { useMultiMenuMeals } from '../common/multi_menu_meals_hook';
import { myFavouritesRecipesBoard } from '../../services/smorg_board';
import { useGetSmorgBoardQuery } from '../../app/smorgAppSyncGraphQLApi';
import { useGetOwnedRecipesBoardsQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const RecipesEndUserFlattenedBoardView = ({
  recipesBoardId,
  menusWithParents,
}) => {
  const navigate = useNavigate();

  const { data: ownRecipesBoard } = useGetSmorgBoardQuery(recipesBoardId, {
    skip: !recipesBoardId,
  });

  const { data: ownedRecipesBoards } = useGetOwnedRecipesBoardsQuery();

  const favouritesRecipesBoardID =
    myFavouritesRecipesBoard(ownedRecipesBoards)?.id;

  const { dedupedMergedEntriesFromMultipleMenus, multiMenusTitle } =
    useMultiMenuMeals(menusWithParents);

  const flattenedFavouriteMealIDs = (ownRecipesBoard?.menus || []).flatMap(
    (menu) =>
      (menu.mealIDs || menu.sharedMealIDs).map((mealID) => ({
        mealID,
        menuID: menu.id,
        parentID: ownRecipesBoard.id,
        isDeleteEnabled: true,
      })),
  );

  const shouldShowEmptyBoardHint =
    ownRecipesBoard &&
    recipesBoardId === favouritesRecipesBoardID &&
    flattenedFavouriteMealIDs.length === 0;

  const title =
    menusWithParents && menusWithParents.length > 0
      ? multiMenusTitle
      : ownRecipesBoard?.title;

  const objects =
    menusWithParents && menusWithParents.length > 0
      ? dedupedMergedEntriesFromMultipleMenus
      : flattenedFavouriteMealIDs;

  const onClickBack = () => navigate(-1);

  return (
    <div className="recipes-view">
      <TopNavBar />
      <MealBasketWidget />
      <div
        className="topNavBarMobile topNavBarMobileLight sticky-on-mobile"
        style={{
          color: 'var(--app-primary-font-color)',
          height: '70px',
          flexDirection: 'column',
        }}>
        <PopupTitle
          titleText={title}
          backButtonEnabled
          onClickBack={onClickBack}
        />
      </div>
      <div>
        <Grid
          container
          className="content-for-sticky-header"
          style={{ paddingLeft: '15px' }}>
          {objects.map(({ mealID, menuID, parentID, isDeleteEnabled }) => (
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              key={mealID}
              style={{ flexShrink: 0 }}>
              <RecipesEndUserMealItem
                mealID={mealID}
                menuID={menuID}
                parentID={parentID}
                favouriteEnabled
                copyEnabled={isDeleteEnabled}
                deleteEnabled={isDeleteEnabled}
                isFullWidth
              />
            </Grid>
          ))}
        </Grid>
        {shouldShowEmptyBoardHint && (
          <div style={{ height: '100%', display: 'flex' }}>
            <div
              style={{
                margin: 'auto',
                color: 'var(--app-primary-font-color)',
              }}>
              Favourite a meal for it to appear here, or copy meals from
              Collections
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

RecipesEndUserFlattenedBoardView.propTypes = {
  recipesBoardId: PropTypes.string,
  menusWithParents: PropTypes.objectOf({
    parentID: PropTypes.string.isRequired,
    menuID: PropTypes.string.isRequired,
  }),
};

RecipesEndUserFlattenedBoardView.defaultProps = {
  recipesBoardId: null,
  menusWithParents: [],
};

export default RecipesEndUserFlattenedBoardView;
